//import produce from 'immer';
import * as types from './types';

const initialState = {
  RepositoryNameList: [],
  usersList: [],
  dfuserList:[],
  jdbclistcopyy:[],
  usersapproveList: [],
  RepositoryNameListfordataen: [],
  refrenceidList: [],
  clientname: null,
  reponame: null,
  reponamefordataen: null,
  srclang: null,
  tgtlang: null,
  description: null,
  reference_id: '',
  quotation_id: '',
  po_num: '',
  opportunity_num:'',
  financialforce_id:'',
  membername: null,
  memberusername: null,
  memberemail: null,
  membertelephone: null,
  memberrole: null,
  memberstatus: null,
  nextaction: null,
  isOrderConfirmed:false,
  translationRate:'',
  totalCost:'',
  shiftid:'',
  customersList:[],
  alldfList:[],
  userlistnotindf:[],
  customerprojectList: [],
  customerdfList:[],
  stagingprojectList: [],
  releasestagingprojectList:[],
  transactions: [],
  filesList: [],
  validfree: true
};

console.log = process.env.NODE_ENV === 'production' ? ()=>{} : console.log;

const reducer = (state = initialState, action) => {
  console.log(action)
  console.log(`action is ---${action.type}${action.payload}`);
  switch (action.type) {
      case 'resetStagingPrjList':
        return {
          ...state,
          stagingprojectList: []
        };

      case 'resetCustomersPrjList':
        return {
          ...state,
          customerprojectList: []
        };

      case types.downloadPrj_SUCCESS:
        return {
          ...state,
          // filesList: action.payload.data
        };

      case types.filesList_SUCCESS:
        return {
          ...state,
          filesList: action.payload.data
        };
      case types.checkfree_ERROR:
        return {
          ...state,
          validfree: false
        };
      case types.checkfree_SUCCESS:
        return {
          ...state,
          validfree: true
        };

      case types.RequestList_SUCCESS:
      return {
        ...state,
        transactions: action.payload.data
      };

    case types.NPRequestList_SUCCESS:
      return {
        ...state,
        transactions: action.payload.data
      };

      case types.stagingPrjList_SUCCESS:
      return {
        ...state,
        stagingprojectList: action.payload.data
      };

    case 'gettranslationstagingforrelease_SUCCESS':
      return {
        ...state,
        releasestagingprojectList: action.payload.data
      };

      case types.customersList_SUCCESS:
      return {
        ...state,
        customersList: action.payload.data
      };

      case types.alldfList_SUCCESS:
      return {
        ...state,
        alldfList: action.payload.data
      };

      case types.customersPrjList_SUCCESS:
      return {
        ...state,
        customerprojectList: action.payload.data
      };
      

      case types.DFUSERSLIST_SUCCESS:
      return {
        ...state,
        dfuserList: action.payload.data
      };

      case types.DELGETDFUSERSLIST_SUCCESS:
      return {
        ...state,
        dfuserList: action.payload.data
      };

      
      case types.ADDUSERTODF_SUCCESS:
        return {
          ...state,
          dfuserList: action.payload.data
        };


      case types.GETUSERLISTNOTINDF_SUCCESS:
        return {
          ...state,
          userlistnotindf: action.payload.data
        };

        case types.CHANGEOWNER_SUCCESS:
          return {
            ...state,
            dfuserList: action.payload.data
          };


      case types.USERSLIST_SUCCESS:
      return {
        ...state,
        usersList: action.payload.data
      };

      
      case types.CUSTOMERDFLIST_SUCCESS:
        return {
          ...state,
          customerdfList: action.payload.data
        };
  
        case types.USERSLIST_SUCCESS:
        return {
          ...state,
          usersList: action.payload.data
        };
      case types.INSERTJDBCLIST:
        return {
          ...state,
          jdbclistcopyy: action.meta.jdbclistcopyy,
        };

    case 'usersapproveList_SUCCESS':
      return {
        ...state,
        usersapproveList: action.payload.data
      };

      case types.ASSESSMENT_SUCCESS:
      return {
        ...state,
        RepositoryNameList: action.payload.data
      };

      case types.ASSESSMENTFORDATASUBMIT_SUCCESS:
      return {
        ...state,
        reference_id: action.payload.data
      };

      case types.ASSESSMENTFORDATA_SUCCESS:   // for data engineer serach repo
      return {
        ...state,
        RepositoryNameListfordataen: action.payload.data
      };

     case types.TRANSAPPROVE_SUCCESS:
      return {
        ...state,
        RepositoryNameList: action.payload.data
      };
    case types.PDFREPORT_SUCCESS:
      return {
        ...state,
        clientname: action.meta.clientname,
        opportunity_num: action.meta.opportunity_num,
        reponame: action.meta.reponame,
        srclang: action.meta.srclang,
        tgtlang: action.meta.tgtlang,
        description: action.meta.description,
        reference_id: action.payload.data
      };

    case types.SAVEAPPROVETRANSLATION:
      return {
        ...state,
        reponame: action.meta.reponame,
        reference_id: action.meta.reference_id,
       // quotation_id: action.meta.reference_id + '-' + action.meta.quotation_id
       opportunity_num: action.meta.opportunity_num,
       quotation_id: action.meta.quotation_id,// +'-' + 'QUOTATION',
       translationRate:action.meta.translationRate,
       clientname:action.meta.clientname
      };

      case types.SAVEORDERREQUEST:
        return {
          ...state,
          reponame: action.meta.reponame,
          reference_id: action.meta.reference_id,
          quotation_id: action.meta.quotation_id,//+ '-' + 'QUOTATION',
          isOrderConfirmed:action.meta.isOrderConfirmed

        };

    case types.SAVETRANSLATION:
      return {
        ...state,
        reponame: action.meta.reponame
      };

      case types.SETFLAG:
      return {
        ...state,
        flag: action.meta.flag
      };

    case types.SELECTROLE:
    return {
      ...state,
      memberrole: action.meta.role
    };


    case types.CHANGEORDERCONFIRMED:
      return {
        ...state,
        isOrderConfirmed: action.meta.isOrderConfirmed
      };


    case types.CHANGEDS:
    return {
      ...state,
      description: action.meta.description
    };

    case types.CHANGESRC:
    return {
      ...state,
      srclang: action.meta.srclang
    };

    case types.CHANGEOPPNUM:
      return {
        ...state,
        opportunity_num: action.meta.opportunity_num
      };


    case types.CHANGEFINID:
    return {
      ...state,
      financialforce_id:action.meta.financialforce_id
    };


    case types.CHANGECLIENTNAME:
    return {
      ...state,
      clientname: action.meta.clientname
    };

    case types.SAVEAPPROVAL:
      return {
        ...state,
        memberrole: action.meta.role,
        nextaction: 'approve'
      };

    case types.SAVEREJECTION:
      return {
        ...state,
        nextaction: 'reject'
      };

    case types.SAVEFINALAPPROVE:                                    //SENDFINALAPPROVE:
      return {
        ...state,
        nextaction: 'sendfinalapprove'
      };

    case types.APPROVETRANSLATION_SUCCESS:
      return {
        ...state,
        reference_id: action.payload.data.reference_id,
        quotation_id: action.payload.data.quotation_id,
        po_num: action.payload.data.po_num
      };

    case types.TRANSLATION_SUCCESS:
      return {
        ...state,
        reference_id: action.payload.data
      };

    case types.USERINFO_SUCCESS:
      return {
        ...state,
        membername: action.payload.data.name,
        memberusername: action.payload.data.username,
        memberemail: action.payload.data.email,
        membertelephone: action.payload.data.phoneNumber,
        memberrole: action.payload.data.role,
        memberstatus: action.payload.data.status
      };

    case types.REFERENCEIDLIST_SUCCESS:
      return {
        ...state,
        refrenceidList: action.payload.data
      };

    case types.TRANSLATIONAPPROVEBYREFERENCEID_SUCCESS:
      return {
        ...state,
        clientname: action.payload.data.clientname,
        srclang: action.payload.data.srclang,
        tgtlang: action.payload.data.tgtlang,
        description: action.payload.data.description,
        reference_id: action.meta.reference_id
      };

      case types.TRANSLATIONAPPROVEBYREFERENCEIDFORQUOTE_SUCCESS:
      return {
        ...state,
        clientname: action.payload.data.clientname,
        reponame: action.payload.data.reponame,
        translationRate: action.payload.data.translationRate,
        opportunity_num: action.payload.data.opportunity_num,
        financialforce_Id: action.payload.data.financialforce_Id,
        reference_id: action.meta.reference_id,
        totalCost: action.payload.data.totalCost
      };

    case types.DOWNLOADRPTBYREFERENCEID_SUCCESS:
      return {
        ...state,
        clientname: action.payload.data.clientname,
        srclang: action.payload.data.srclang,
        tgtlang: action.payload.data.tgtlang,
        description: action.payload.data.description,
        reference_id: action.meta.reference_id
      };

      case types.DOWNLOADRPTBYUSERNAMEANDREFERENCEID_SUCCESS:
      return {
        ...state,
        clientname: action.payload.data.clientname,
        srclang: action.payload.data.srclang,
        tgtlang: action.payload.data.tgtlang,
        description: action.payload.data.description,
        reference_id: action.meta.reference_id
      };

    case types.DOWNLOADREPORT_SUCCESS:
      return {
        ...state,
        reference_id: action.meta.reference_id
      };


      case types.TRANSDOWNLOADREPORT_SUCCESS:
        return {
          ...state,
          //clientname: action.payload.data.clientname,
          srclang: action.payload.data.srclang,
          tgtlang: action.payload.data.tgtlang,
          description: action.payload.data.description,
          reference_id: action.meta.reference_id
        };


    case types.GETRPTLNKBYREFERENCEID:
      return {
        ...state,
        reference_id: action.meta.reference_id
      };

      case types.GETQUOTBYPO_SUCCESS:
        return {
          ...state,
          reponame: action.payload.data.reponame,
          reference_id: action.payload.data.reference_id,
          opportunity_num: action.payload.data.opportunity_num,
          clientname: action.payload.data.clientname,
          translationRate: action.payload.data.translationRate,
         // quotation_id:  action.payload.data.quotation_id,
          quotation_id: action.meta.quotation_id,
          po_num: action.meta.po_num
        };

    case types.SAVEMEMBERNAME:
      return {
        ...state,
        memberusername: action.meta.username
      };

      case types.KEEPQUO:
        return {
          ...state,
          quotation_id: action.meta.quotation_id
        };


    case types.TRANSLATIONBYPONUMBER_SUCCESS:
      return {
        ...state,
        reference_id: action.payload.data.reference_id,
        clientname: action.payload.data.clientname,
        opportunity_num: action.payload.data.opportunity_num,
        srclang: action.payload.data.srclang,
        tgtlang: action.payload.data.tgtlang,
        description: action.payload.data.description
      };

      case types.TRANSLATIONBYREPONAME_SUCCESS:
      return {
        ...state,
        reference_id: action.payload.data.reference_id,
        clientname: action.payload.data.clientname,
        opportunity_num: action.payload.data.opportunity_num,
        financialforce_id: action.payload.data.financialforce_id,
        srclang: action.payload.data.srclang,
        tgtlang: action.payload.data.tgtlang,
        description: action.payload.data.description
      };


      case types.ACCESSMENTBYREPONAME_SUCCESS:
        return {
          ...state,
          reference_id: action.payload.data.reference_id,
          clientname: action.payload.data.clientname,
          opportunity_num: action.payload.data.opportunity_num,
          financialforce_id: action.payload.data.financialforce_id,
          srclang: action.payload.data.srclang,
          tgtlang: action.payload.data.tgtlang,
          description: action.payload.data.description
        };

   // case types.RESET_ASSESSMENT_STORE_SUCCESS:
   case types.RESET_ASSESSMENT_STORE:
      return {
        ...state,
        RepositoryNameList: [],
        RepositoryNameListfordataen: [],
        refrenceidList: [],
        clientname: null,
        opportunity_num: null,
        reponame: null,
        reponamefordataen:null,
        srclang: null,
        tgtlang: null,
        description: null,
        reference_id: '',
        quotation_id: '',
        po_num: '',
        translationRate:'',
        financialforce_id:'',
        isOrderConfirmed:false,
        totalCost:'',
        shiftid:'',
        membername: null,
        memberusername: null,
        memberemail: null,
        membertelephone: null,
        memberrole: null,
        memberstatus: null,
        nextaction: null
      };
    default:
      return state;
  }
};

export default reducer;



// WEBPACK FOOTER //
// ./src/state/assessment/reducer.js